/**
 * Utilities for generating unique and secure IDs
 */

/**
 * Generates a unique and cryptographically secure ID
 * @param {string} prefix - Optional prefix for the ID
 * @returns {string} Unique ID in the format `{prefix}-{timestamp}-{random}`
 * @throws {Error} If no random number generator is available
 */
export const generateSecureId = (prefix = 'id') => {
  const timestamp = Date.now()
  const crypto = globalThis.crypto || globalThis.msCrypto

  if (crypto?.getRandomValues) {
    const array = new Uint32Array(4)
    crypto.getRandomValues(array)

    const randomString = Array.from(array, (val) => val.toString(36)).join('')

    return `${prefix}-${timestamp}-${randomString}`
  }

  throw new Error('Cryptographically secure random number generator not available')
}

/**
 * Ensures an item has an ID, generating a fallback if necessary
 * @param {Object} item - Item to be checked
 * @param {string} item.id - Existing ID (optional)
 * @param {number} index - Item index (used in fallback)
 * @param {string} prefix - Prefix for the fallback ID
 * @returns {string} Item ID or generated ID
 */
export const ensureItemId = (item, index, prefix = 'item') => {
  return item.id || `${prefix}-${index}-${Date.now()}`
}
